export const PROVIDER_REPORTS = [
  {
    slug: "uploaded-debt-portfolio",
    name: "Uploaded Debt Portfolio Report",
    purpose: "Shows all debt portfolios and batches submitted by your institution.",
    filters: ["date", "batch_id", "processing_status", "ageing_bucket"],
  },
  {
    slug: "defaulter-debtor",
    name: "Defaulter/Debtor Detailed Report",
    purpose: "Provides case-level visibility of submitted debtors.",
    filters: ["date", "batch_id", "case_status", "ageing_bucket", "search"],
  },
  {
    slug: "collections-recovery",
    name: "Collections/Recovery Report",
    purpose: "Shows money recovered from assigned portfolios.",
    filters: ["date", "payment_status", "payment_type", "payment_channel"],
  },
  {
    slug: "revenue",
    name: "Daily/Weekly/Monthly Revenue Report",
    purpose: "Shows recovery performance over selected periods.",
    filters: ["date", "period"],
  },
  {
    slug: "payment-transaction-history",
    name: "Payment Transaction History Report",
    purpose: "Complete transaction history for debtors.",
    filters: ["date", "payment_status", "payment_channel", "search"],
  },
  {
    slug: "outstanding-debt-ageing",
    name: "Outstanding Debt & Ageing Report",
    purpose: "Monitors remaining portfolio exposure by ageing bucket.",
    filters: ["date", "batch_id", "ageing_bucket", "case_status"],
  },
  {
    slug: "case-status",
    name: "Case Status Report",
    purpose: "Shows progress of all cases submitted by your institution.",
    filters: ["date", "batch_id", "case_status"],
  },
  {
    slug: "reconciliation",
    name: "Reconciliation Report",
    purpose: "Reconciles collections against settlement obligations.",
    filters: ["date", "reconciliation_status"],
  },
  {
    slug: "portfolio-performance-summary",
    name: "Portfolio Performance Summary",
    purpose: "Executive view of portfolio recovery performance.",
    filters: ["date", "period"],
  },
];

export function getProviderReport(slug) {
  return PROVIDER_REPORTS.find((report) => report.slug === slug) || null;
}

export function reportPath(slug) {
  return `/dashboard/reports/${slug}`;
}

export const REPORT_NAV_CHILDREN = PROVIDER_REPORTS.map((report) => ({
  label: report.name,
  description: report.purpose,
  path: reportPath(report.slug),
}));
